// node_modules
import React, { useState } from "react";
import { Button } from "primereact/button";
import { useNavigate } from "react-router";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";

// components
import { FileInput } from "../../components/FileInput";

// styles
import * as styles from "./Upload.module.css";

export const Upload = () => {
  const navigate = useNavigate();
  const [isAnalyzing, setIsAnalyzing] = useState(false);

  const handleSubmit = () => {
    setIsAnalyzing(true);
    setTimeout(() => {
      navigate("/table");
    }, 5000);
  };

  return (
    <div className={styles.wrapper}>
      {isAnalyzing ? (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "800px",
          }}
        >
          <DotLottieReact src="./Analyze.lottie" loop autoplay />
        </div>
      ) : (
        <FileInput onSubmit={handleSubmit} />
      )}
    </div>
  );
};
